import { useQuery } from "@tanstack/react-query"
import { useContext } from "react"
import { UserContext } from "../app/context/UserContext"
import { DimaFeatureShortNameEnum } from "../app/models/Authorization"
import { RoleRequestGet } from "../app/models/RoleRequest"
import { digitalManagerApi } from "../services/api"

export function useRoleRequestsBadge() {
  const { user, isLoadingUser } = useContext(UserContext)

  const hasPermission =
    !!user &&
    user.authorizations.applications?.some(
      (app) => app.featuresAccesses?.[DimaFeatureShortNameEnum.RR] >= 1
    )

  const hasPendingApproval = (rr: RoleRequestGet) =>
    rr.approvals.some((a) => a.userApproverType !== null && a.completionDate === null)

  const fetchBadge = () =>
    digitalManagerApi
      .get<RoleRequestGet[]>("/roleRequests", { params: { completed: false } })
      .then((r) => r.data.filter(hasPendingApproval).length)

  const { data: roleRequestsBadge = 0, isLoading: isLoadingQuery } = useQuery<number>({
    queryKey: ["roleRequestsBadge"],
    queryFn: fetchBadge,
    enabled: hasPermission,
  })

  return {
    roleRequestsBadge,
    isLoadingRoleRequestsBadge: isLoadingUser || isLoadingQuery,
  }
}
